import { QueryClient, useQuery } from '@tanstack/react-query';

import { AxiosRequestConfig } from 'axios';

import { getLatestCalculatedLotteryResults, getLotteryResults } from '../moduleSelectionService';

export enum MODULE_SELECTION_LOTTERY_KEY {
  RESULTS = 'module-selection-lottery-results',
  RESULTS_BY_MODULE = 'module-selection-lottery-results-by-module'
}

export const invalidateLotteryResultsByModule = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({
    predicate: query => {
      return query.queryKey.includes(MODULE_SELECTION_LOTTERY_KEY.RESULTS_BY_MODULE);
    }
  });
};

export const invalidateLotteryResults = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({
    predicate: query => {
      return query.queryKey.includes(MODULE_SELECTION_LOTTERY_KEY.RESULTS);
    }
  });
};

export const useLotteryResultsByModuleQuery = (
  moduleId: number,
  enabled: boolean = false,
  config?: AxiosRequestConfig
) => {
  const queryKey = [
    MODULE_SELECTION_LOTTERY_KEY.RESULTS_BY_MODULE,
    moduleId,
    config ? JSON.stringify(config.params) : ''
  ];
  return useQuery({
    queryKey: queryKey,
    queryFn: () => {
      return getLotteryResults(moduleId, config);
    },
    enabled
  });
};

export const useLatestCalculatedLotteryResults = (
  selectionId: number,
  config?: AxiosRequestConfig
) => {
  const queryKey = [MODULE_SELECTION_LOTTERY_KEY.RESULTS];
  return useQuery({
    queryKey,
    queryFn: () => {
      return getLatestCalculatedLotteryResults({
        ...config,
        params: { ...config?.params, moduleSelectionId: selectionId }
      });
    }
  });
};
